import React from 'react';
import {Dropdown, DropdownButton} from 'react-bootstrap';

import {service as ActivityFeedFilterService} from "../../../Services/ActivityFeedFilterService";
import {usePrimeCache} from "../../../Hooks/ServiceHooks";
import {ActivityFeedFilterFieldEditor} from "../../../Models/Core/FieldEditors/ActivityFeedFilterFieldEditor";


export const SubscriptionsPageRecord = (props) => {

    const { Item, UpdateItem } = props;

    usePrimeCache([ActivityFeedFilterService]);
    
    const filters = ActivityFeedFilterService.CachedValues()?.result ?? null;
    
    if(!filters) { return "Loading..."; }

    return (
        <ActivityFeedFilterFieldEditor
            Value={Item?.activityFeedFilterId ?? null}
            OnUpdate={(value) => {
                console.log('Updating activityFeedFilterId to:', value);
                UpdateItem({
                    ...Item,
                    activityFeedFilterId: value,
                });
            }}
            className="sb-subscription-filter-field-editor"
        />
    );
};